import React from 'react';
import { AddDogDialog } from '@/components/AddDogDialog';

export function AddDogDialogWrapper(props) {
  return <AddDogDialog {...props} />;
}